import api from '../configs/api.config';
import { downloadBlob } from '../helpers/utils';
import { WEFResponse } from '../Types';
import {
  PlateRegistrationFile,
  PlateRegistrationSummary,
  RegistrationExportPreview,
  RegistrationExportRequest
} from '../types/plateRegistration.types';

export const uploadPlateRegistration = async (plateId: string, formData: FormData) => {
  const { data } = await api.post<WEFResponse<PlateRegistrationFile>>(
    `/PlateRegistration/${plateId}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );
  return data?.data;
};

export const getCurrentPlateRegistration = async (plateId: string) => {
  const { data } = await api.get<WEFResponse<PlateRegistrationFile | null>>(
    `/PlateRegistration/${plateId}`
  );
  return data?.data ?? null;
};

export const getPlateRegistrationHistory = async (plateId: string) => {
  const { data } = await api.get<WEFResponse<PlateRegistrationFile[]>>(
    `/PlateRegistration/${plateId}/history`
  );
  return data?.data ?? [];
};

export const getPlateRegistrationDownloadUrl = async (fileId: string) => {
  const { data } = await api.get<WEFResponse<string>>(
    `/PlateRegistration/file/${fileId}/download-url`
  );
  return data?.data;
};

export const deletePlateRegistration = async (fileId: string) => {
  const { data } = await api.delete<WEFResponse<boolean>>(`/PlateRegistration/file/${fileId}`);
  return data?.data;
};

export const getClientRegistrationSummary = async (clientId: string) => {
  const { data } = await api.get<WEFResponse<PlateRegistrationSummary[]>>(
    `/PlateRegistration/client/${clientId}/summary`
  );
  return data?.data ?? [];
};

export const previewRegistrationExport = async (payload: RegistrationExportRequest) => {
  const { data } = await api.post<WEFResponse<RegistrationExportPreview>>(
    '/PlateRegistration/export/preview',
    payload
  );
  return data?.data;
};

export const downloadRegistrationExport = async (
  payload: RegistrationExportRequest,
  chunkIndex: number,
  fallbackFileName: string
) => {
  const response = await api.post(`/PlateRegistration/export?chunkIndex=${chunkIndex}`, payload, {
    responseType: 'blob'
  });

  // 204 means the filters matched nothing.
  if (response.status === 204) return false;

  const contentDisposition = response.headers['content-disposition'];
  const match = contentDisposition?.match(/filename="(.+)"/);
  const fileName = match ? match[1] : fallbackFileName;

  downloadBlob(response?.data, fileName);
  return true;
};
